import { render } from "./Notes2.vue?vue&type=template&id=809c6b24&scoped=true"
import script from "./Notes2.vue?vue&type=script&lang=js"
export * from "./Notes2.vue?vue&type=script&lang=js"

import "./Notes2.vue?vue&type=style&index=0&id=809c6b24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-809c6b24"]])

export default __exports__